import classNames from 'classnames'

import { Translation } from 'cng-common/features/translations/components/translation'
import { getFormatDate, toFormat } from 'core/classes/helpers/DateHelper'

import { ISimpleFieldProps } from './SimpleField'

import styles from './SimpleField.module.scss'

interface IDateFieldProps extends ISimpleFieldProps {
  format?: string
  onClick?: () => void
  localFormat?: boolean
}

export const DateField = ({
  item,
  field,
  label,
  format,
  className,
  onClick,
  translate,
  value,
  size = 'normal',
  localFormat = false,
}: IDateFieldProps) => {
  return (
    <p className={classNames(styles.root, className || '')}>
      {label && (
        <span className={classNames(styles.label, size !== 'normal' && styles[`label__${size}`])}>
          {translate ? <Translation text={label} span actionsInside /> : label}:
        </span>
      )}
      <span
        className={classNames(styles.value, onClick ? styles['value--clickable'] : '')}
        onClick={onClick}
      >
        {value
          ? value
          : item[field]
            ? localFormat
              ? `${getFormatDate(item[field], 'date3')} ${getFormatDate(item[field], 'time')}`
              : format
                ? toFormat(item[field] || '', format)
                : item[field]
            : '-'}
      </span>
    </p>
  )
}
